module.exports = __webpack_public_path__ + "static/fern-5300817bcfc92750e938e53dec44a1b2.png";